import React from 'react';

const SvgSz = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SZ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <ellipse id="SZ_svg__c" cx={6} cy={3.333} rx={6} ry={3.333} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SZ_svg__b" fill="#fff">
        <use xlinkHref="#SZ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#SZ_svg__a" />
      <path
        fill="#486BCA"
        mask="url(#SZ_svg__b)"
        d="M0 0h28v4H0zM0 16h28v4H0z"
      />
      <path fill="#FFDF20" mask="url(#SZ_svg__b)" d="M0 4h28v12H0z" />
      <path fill="#CF1615" mask="url(#SZ_svg__b)" d="M0 5.333h28v9.333H0z" />
      <g mask="url(#SZ_svg__b)">
        <g transform="translate(8 6.667)">
          <mask id="SZ_svg__d" fill="#fff">
            <use xlinkHref="#SZ_svg__c" />
          </mask>
          <use fill="#FFF" xlinkHref="#SZ_svg__c" />
          <path
            fill="#262626"
            mask="url(#SZ_svg__d)"
            transform="matrix(-1 0 0 1 6.667 0)"
            d="M0 0h6.667v6.667H1.333z"
          />
          <circle
            fill="#1A1A1A"
            mask="url(#SZ_svg__d)"
            cx={7.333}
            cy={3.333}
            r={1}
          />
          <circle
            fill="#F6F6F6"
            mask="url(#SZ_svg__d)"
            cx={4.667}
            cy={3.333}
            r={1}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgSz;
